import React, { useEffect, useState } from "react";
// import logo from './logo.svg';
import "./IndividualResult.scss";
import GreenButton from "../Components/GreenButton";
import InitialFooter from "../Components/InitialFooter";
import logo from "../Images/ge-healthcare-logo-white.png";
import cong from "../Images/Vector (10).png";
import Lottie from "lottie-react";
import congratulationsAnim from "../Lotties/congratulations.json";
import { useParams, useNavigate } from "react-router";
import ReturnHome from "../Components/ReturnHome";
import ModalCover from "../Components/ModalCover";
import ModalButtonsDisplay from "../Components/ModalButtonsDisplay";
import { getCollection } from "../WebMethods/ReadCollection";
import getScore from "../Utils/getScore";
import viewNavigate from '../Utils/viewNavigate'
import useIdle from "../Hooks/useIdle";

const IndividualResult = (props) => {
  const isIdle = useIdle();
  const [downloaded, setDownloaded] = useState(false);
  const [ranking, setRanking] = useState(0);
  const responses = props.responses;
  useEffect(() => {
    (async () => {
      const firebaseDataRaw = await getCollection("answers");
      const firebaseData = firebaseDataRaw.filter(elem => !elem.removed)
      firebaseData.sort((a, b) => b.totalScore - a.totalScore);
      setDownloaded(true);
      const playerScore = getScore(responses);
      const indexRaw = firebaseData.findIndex(
        (elem) => elem.totalScore < playerScore
      );
      const index = indexRaw === -1 ? firebaseData.length + 1 : indexRaw + 1;
      props.setUsers(firebaseData);
      setRanking(index);
    })();
  }, []);
  let navigate = useNavigate();
  const [retunHome, setRetunHome] = useState(false);
  return (
    <>
      <div className="holder-result">
        <div className="container-result">
          <img src={logo} alt="GE HealthCare" className="logo-result" />
          <img
            className="congratulation-result"
            src={cong}
            alt="congratulation"
          />
          <p className="congratulation-result-text">Congratulations!</p>
          <div className="score-holder-result">
            <div className="vertical-line-result">
              <div className="score-value-display">
                <p>Score</p>
                <p className="score-value-display-number">
                  {getScore(responses)}
                </p>
              </div>
              <div className="score-value-display">
                <p>Ranking</p>
                <p className="score-value-display-number">{ranking}</p>
              </div>
            </div>
          </div>
          <GreenButton
            disabled={!downloaded}
            onClick={() => {
              viewNavigate(navigate, `/EnterDataResult`);
            }}
          >
            Add Score to Leaderboard
          </GreenButton>
        </div>
        <div className="bottom-actions">
          <ReturnHome
            style={{ color: "white" }}
            white={true}
            onClick={() => setRetunHome(true)}
          />
        </div>
        <div style={{ left: "-40%" }} className="lottie-holder-result">
          <Lottie animationData={congratulationsAnim} loop={2} />
        </div>
        <div style={{ right: "-40%" }} className="lottie-holder-result">
          <Lottie animationData={congratulationsAnim} loop={2} />
        </div>
      </div>
      {retunHome && (
        <ModalCover>
          <ModalButtonsDisplay
            title={"Are you sure?"}
            text={"The game will end, and you can start a new session."}
            denyText={"Cancel"}
            deny={() => {
              setRetunHome(false);
            }}
            accept={() => {
              viewNavigate(navigate, `/`);
            }}
            acceptText={"Retun To Home"}
          />
        </ModalCover>
      )}
    </>
  );
};
export default IndividualResult;
